import React from 'react';
import styled from 'styled-components';

import ComplexResultContainer from '../../containers/retention/complex/RetentionResult';
import RetentionTemplateDrawerMenu from '../../containers/retention/complex/RetentionTemplateDrawerMenu';
import RetentionComplexHeader from './RetentionComplexHeader';
import RetentionComposeContainer from '../../containers/retention/complex/RetentionComposeContainer';
import NavigationBar from '../navigation/NavigationBar';
import SpinnerWithButton from '../common/SpinnerWithButton';

const RetentionComplexContainer = styled.div`
  display: flex;
  flex-direction: row;
  height: calc(100% - 63px);
  justify-content: space-between;

  .retention__wrapper {
    width: 100%;
    display: flex;
    flex-direction: row;
    height: 100%;
    overflow-y: auto;
  }

  .retention__main {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: flex-start;
    padding: 20px;
  }
`;

const RetentionComplex = ({
  executing,
  onExecute,
  executeDisabled,
  extraActions,
  onRequestCancel,
  cancelButtonDisabled,
}) => (
  <>
    <NavigationBar
      onExecute={onExecute}
      executeDisabled={executeDisabled || executing}
      extraActions={extraActions}
    />
    <RetentionComplexContainer>
      <div className="st-retention-view retention__wrapper">
        <SpinnerWithButton
          onClick={onRequestCancel}
          disabled={cancelButtonDisabled}
          executing={executing}
        >
          <div className="retention__main">
            <RetentionComplexHeader />
            <RetentionComposeContainer />
            <ComplexResultContainer />
          </div>
        </SpinnerWithButton>
      </div>
      <RetentionTemplateDrawerMenu />
    </RetentionComplexContainer>
  </>
);

export default RetentionComplex;
